
































































import Vue from 'vue'
import { Component, Mixin, Lifecycle } from 'av-ts'
import { EventBus, NotifOptions } from '@/eventbus'
import { IUser } from '@/models'

// export default class App extends Vue {
@Component({
  store:  ['initialized', 'initError', 'isDev', 'user']
})
export default class App extends Mixin(EventBus) {
  name = 'App'
  snackbar = {
    show: false,
    text: 'Empty !',
    closeable: true,
    timeout: 0,
    color: ''
  }

  @Lifecycle
  created() {
    console.debug('App created', this)
    this.eventBus.$on('error', (msg: string) =>  {
      console.error('EventBus ERROR msg=', msg)
      this.showSnackbar(msg, 'error')
    })
    this.eventBus.$on('notif', (msg: string, options?: NotifOptions) =>  {
      console.info('EventBus NOTIF msg=', msg, options)
      if (options)
        this.showSnackbar(msg, options.context, options.timeout || 0)
      else
        this.showSnackbar(msg)
    })
  }

  private showSnackbar(text: string, color: string = '', timeout: number = 0) {
    this.snackbar.text = text
    this.snackbar.color = color
    this.snackbar.timeout = timeout
    this.snackbar.show = true
  }

  hideSnackbar() {
    this.snackbar.show = false
  }

  logout(user: IUser) {
    console.debug('[App.vue] logout user', user)
    this.$store.logout()
  }
}
